import styles from './Footer.module.scss';
import { FooterAbove } from './FooterAbove';

import type { AuthorizationRequest } from '../../types';
import type { DefaultProps } from '../../types/DefaultProps';
import type { RedirectUriAfterRegistration } from '../../types/RedirectUriAfterRegistration';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC } from 'react';

export type FooterProps = DefaultProps & {
  appEnv: AppEnv;
  isLoggedIn: boolean;
  authorizationRequest?: AuthorizationRequest;
  redirectUriAfterRegistration?: RedirectUriAfterRegistration;
};

export const FooterUnder: FC = () => (
  <div className={styles['block-footer-under']}>
    <div className={styles['block-copyright']}>
      Copyright &copy; SMS Co., Ltd. All Rights Reserved.
    </div>
  </div>
);

export const Footer: FC<FooterProps> = ({
  appEnv,
  isLoggedIn,
  authorizationRequest,
  redirectUriAfterRegistration,
}) => (
  <div className={styles.wrap}>
    <FooterAbove
      appEnv={appEnv}
      isLoggedIn={isLoggedIn}
      authorizationRequest={authorizationRequest}
      redirectUriAfterRegistration={redirectUriAfterRegistration}
    />
    <FooterUnder />
  </div>
);
